import React, { useMemo, useEffect, useState, useRef, useCallback } from 'react'
import { withTranslator } from '../HOCComponents/withTranslator'

// THIS COMPONENT IS VIBE CODED AND CAN BE REMOVED OR COMPLETLY REWRITTEN IF NEEDED
// Only needs to display the toast when user has the role ROLE_PAYWALL_PERSISTENT_WARNING
// and not be removed by ad blockers or other external factors

// Generate random class names to avoid ad blocker detection
const generateClassName = () => {
  const chars = 'abcdefghijklmnopqrstuvwxyz'
  const randomChar = () => chars[Math.floor(Math.random() * chars.length)]
  return `${randomChar()}${randomChar()}${randomChar()}${randomChar()}${randomChar()}${randomChar()}`
}

// Static style objects (reused across renders to avoid object recreation)
const CONTAINER_STYLE = {
  position: 'fixed',
  bottom: '20px',
  left: 80,
  right: 80,
  color: 'white',
  display: 'flex',
  justifyContent: 'center',
  gap: '12px',
  zIndex: 100,
  fontFamily: 'Roboto, sans-serif',
  fontSize: '14px',
  lineHeight: '1.5',
  pointerEvents: 'auto'
}

const CONTENT_STYLE = {
  display: 'flex',
  alignItems: 'center',
  padding: '16px 20px',
  borderRadius: '8px',
  backgroundColor: '#991b1b',
  gap: '12px',
  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)'
}

const ICON_STYLE = {
  fontSize: '20px',
  flexShrink: 0
}

const TEXT_STYLE = {}

const BOLD_STYLE = {
  fontWeight: 'bold'
}
// Generate random ID to avoid blocking
const generateRandomId = () => {
  const chars = 'abcdefghijklmnopqrstuvwxyz'
  const randomChar = () => chars[Math.floor(Math.random() * chars.length)]
  return `${randomChar()}${randomChar()}${randomChar()}${Date.now().toString(36)}${Math.random().toString(36).substr(2, 5)}`
}

// Check if element is hidden by external manipulation
const isElementHidden = element => {
  if (!element) return true
  const style = window.getComputedStyle(element)
  return style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0' || element.offsetParent === null
}

const PaymentWarningToast = ({ hasRolePaywallPersistentWarning, t }) => {
  const [renderKey, setRenderKey] = useState(Date.now)
  const elementRef = useRef(null)
  const observerRef = useRef(null)

  // Force re-render with new IDs
  const regenerate = useCallback(() => {
    setRenderKey(prev => prev + 1)
  }, [])

  // Periodic regeneration every 30 seconds
  useEffect(() => {
    if (hasRolePaywallPersistentWarning) {
      const intervalId = setInterval(regenerate, 30000)
      return () => clearInterval(intervalId)
    }
  }, [hasRolePaywallPersistentWarning, regenerate])

  // MutationObserver to detect removal or hiding
  useEffect(() => {
    if (!hasRolePaywallPersistentWarning) return

    const checkVisibility = () => {
      if (elementRef.current && isElementHidden(elementRef.current)) {
        regenerate()
      }
    }

    // Watch for DOM mutations that might hide/remove our element
    observerRef.current = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        // Check if our element was removed
        if (mutation.type === 'childList') {
          for (const removed of mutation.removedNodes) {
            if (removed === elementRef.current || removed.contains?.(elementRef.current)) {
              regenerate()
              return
            }
          }
        }
        // Check for style/attribute changes that hide the element
        if (mutation.type === 'attributes' && mutation.target === elementRef.current) {
          checkVisibility()
        }
      }
    })

    observerRef.current.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden']
    })

    // Also check periodically in case observer misses something
    const visibilityCheck = setInterval(checkVisibility, 10000)

    return () => {
      observerRef.current?.disconnect()
      clearInterval(visibilityCheck)
    }
  }, [hasRolePaywallPersistentWarning, regenerate])

  // Generate unique class names on each render to avoid pattern matching
  const { containerId, containerClass, iconClass, textClass, boldClass } = useMemo(
    () => ({
      containerId: generateRandomId(),
      containerClass: generateClassName(),
      iconClass: generateClassName(),
      textClass: generateClassName(),
      boldClass: generateClassName(),
      _trigger: renderKey // Forces regeneration when renderKey changes
    }),
    [renderKey]
  )

  if (!hasRolePaywallPersistentWarning) {
    return null
  }

  return (
    <div ref={elementRef} key={containerId} id={containerId} className={containerClass} style={CONTAINER_STYLE}>
      <div style={CONTENT_STYLE}>
        <span className={iconClass} style={ICON_STYLE}>
          <i className="fa-solid fa-triangle-exclamation" />
        </span>
        <span className={textClass} style={TEXT_STYLE}>
          <span className={boldClass} style={BOLD_STYLE}>
            {t('Hemos detectado una incidencia en el cobro.')}
          </span>{' '}
          {t('Por favor contacte con el responsable de pagos para evitar bloqueo del acceso y servicio.')}
        </span>
      </div>
    </div>
  )
}

export default withTranslator(PaymentWarningToast)
